export const URL_BOC = 'https://raboweblogin.rabobank.nl/rwalogin/isapilogin.dll?URL=https://boc.rabobank.nl';
